<template>
  <EstateAssistContainer
    :testator="testator"
    :quotes="quotes"
    :startLeadBody="startLeadBody"
    :peopleRelations="peopleRelations"
    :buttonLoading="buttonLoading"
    @updateInsuranceAndRequestQuotes="updateInsuranceAndRequestQuotes"
    @updateInsurance="updateInsurance"
    @startLead="startLead"
  />
</template>

<script>
  import EstateAssistContainer from './EstateAssistContainer.vue';
  export default {
    name: 'InsuranceProducts',
    components: {
      EstateAssistContainer,
    },
    methods: {
      updateInsuranceAndRequestQuotes(params, skipLoading) {
        this.$emit('updateInsuranceAndRequestQuotes', params, skipLoading);
      },
      updateInsurance(params) {
        this.$emit('updateInsurance', params);
      },
      startLead() {
        this.$emit('startLead');
      },
    },
    props: {
      testator: {
        required: true,
        type: Object,
      },
      quotes: {
        required: true,
        type: Array,
      },
      startLeadBody: {
        required: false,
        type: Object,
      },
      peopleRelations: {
        type: Object,
        required: true,
      },
      buttonLoading: {
        default: false,
        type: Boolean,
      },
    },
  };
</script>
